import { useCallback } from 'react';
// eslint-disable-next-line max-len -- long hook name
import { useCreateStripeSubscriptionManagementUrlMutation } from 'shared/hooks/queries/use-create-stripe-subscription-management-url-mutation';
import { useTrackEvents } from 'shared/hooks/use-track-events';
import { ActionEvents } from 'shared/services/tracking';
import { ID } from 'shared/types/id';

export const useOpenSubscriptionManagement = () => {
  const track = useTrackEvents();
  const { mutateAsync, isPending } =
    useCreateStripeSubscriptionManagementUrlMutation();

  const submit = useCallback(
    async (stripeCustomerId: ID) => {
      track(ActionEvents.CancelSubscription, undefined);

      return mutateAsync(stripeCustomerId);
    },
    [mutateAsync, track],
  );

  return {
    submit,
    isLoading: isPending,
  };
};
